<template>
  <div>
    <template>
      <a-modal v-model="visible" title="Tiempo límite" :footer="null">
        <a-result status="warning"
                  title="La fecha de Novedad ha caducado para el Calendario de Nomina Activo, por favor consulte su administrador HRO">
          <template #extra>
            <a-button @click="handleOk" type="primary">
              Cerrar
            </a-button>
          </template>
        </a-result>
      </a-modal>
    </template>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
        <span slot="tab">
          <g-wiki keyValue="WIKI_OCA"/>
          Novedades Ocasionales
        </span>
        <g-master name="ocasionales"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :actions="master.actions"
                  @action="masterAction"
                  ref="masterComponent"
                  modalWidth="80%"
                  @params="paramsTable"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <template slot="expandedRowRender" slot-scope="{text}">
            <template v-for="ve in master.valoresExpandidos">
              {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
            </template>
          </template>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Concepto')"
                          :formItemConfig="fiOptions"
                          endpoint="coc"
                          :decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                          ref="cocComponent"
                          :params="filtro_grupo"
                >
                </g-lookup>
              </a-col>

              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Empleados')"
                          :formItemConfig="fiOptions"
                          :selectedObj.sync="empleadoseleccionado"
                          endpoint="empleado_act_ret_liq_def"
                          ref="empComponent"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                >
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Unidad')">
                  <a-input
                    v-decorator="['oca_und', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Valor base')">
                  <a-input-number style="width: 100%" step="1"
                                  v-decorator="['oca_base', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  ></a-input-number>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Valor local')">
                  <a-input-number style="width: 100%" step="1"
                                  v-decorator="['oca_valor_l', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  ></a-input-number>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha Liquidación')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['oca_date_liq', { rules: [{ required: true, message: 'Valor requerido' }],
                                 initialValue: now}]">
                  </a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha Novedad')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['oca_date_reg', { rules: [{ required: true, message: 'Valor requerido' }],
                                               initialValue: now}]">
                  </a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown v-bind="fiOptions"
                            endpoint="hierarchy_lookup"
                            :label="$t('Proceso')"
                            :formItemConfig="fiOptions"
                            :decorator="['prc', { rules: [{ required: true, message: 'Valor requerido'}]}]"
                            :params="prc"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Documento')">
                  <a-input
                    v-decorator="['oca_document', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            style="width: 100%"
                            :label="$t('Moneda')"
                            :formItemConfig="fiOptions"
                            :decorator="['currency', { rules: [{ required: true, message: 'Valor requerido'}], initialValue: 'COP'}]"
                            :params="code_currency">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Descripción')">
                  <a-textarea autoSize
                              v-decorator="['description', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Centro de Costo')"
                            endpoint="cc"
                            :rowKey="'id'"
                            :columns="columnasCentroCosto"
                            :saveValue="'id'"
                            :hasMultipleRows="true"
                            @model="modeloRecibido"
                            :formItemConfig="fiOptions"
                            :decorator="['id_cc', { rules: [{ required: false, message: 'Valor requerido' }]}]">
                </g-dropdown>
              </a-col>
            </a-row>
            <a-card v-if="verCar">
              <a-alert
                message="Advertencia"
                :description="error"
                type="warning"
                show-icon
              />
            </a-card>
          </template>
        </g-master>
      </a-tab-pane>
      <a-tab-pane key="2" v-if="roleLoad">
        <span slot="tab">
          <g-wiki width="50%" keyValue="WIKI_CARGUE_OCA">
            <template slot="customText">
              <a-button type="primary" value="large" :loading="loadingTemplate" @click="downloadTemplate">
                <a-icon type="file-excel"/>
                Plantilla excel
              </a-button>
            </template>
          </g-wiki>
          Cargue Masivo Ocasionales
        </span>
        <cargue_oca @loadData="loadData"/>
      </a-tab-pane>
      <a-tab-pane tab="Novedades Ocasionales Historico" key="3">
        <oca-hist/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
      this.now = moment().format('Y-MM-DD HH:mm:ss')
      this.limiteRegistroNovedad()
      this.isRolQuery()
    },
    data () {
      return {
        verCar: false,
        error: '',
        fecha_inicio: null,
        id_emp: null,
        empleadoseleccionado: {},
        loadingTemplate: false,
        fileNameExcel: 'novedades_oca',
        paramsT: {},
        columnasCentroCosto: [
          {title: 'ID', dataIndex: 'id', sorter: true},
          {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_CENTRO_DE_COSTOS'), dataIndex: 'cc_id', sorter: true},
          {title: 'Nombre CC', dataIndex: 'cc_name', sorter: true},
          {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_SEGMENTO'), dataIndex: 'segment_id', sorter: true},
          {title: 'Nombre Segmento', dataIndex: 'segment_name', sorter: true},
          {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_UNIDAD'), dataIndex: 'unit_id', sorter: true},
          {title: 'Nombre Unidad', dataIndex: 'unit_name', sorter: true},
          {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_PROYECTO'), dataIndex: 'prj_id', sorter: true},
          {title: 'Nombre Proyecto', dataIndex: 'prj_name', sorter: true}
        ],
        endpointExcel: 'oca_novedades/downloadExcel',
        pageTitle: 'Novedades Ocacionales',
        filtro_grupo: {filtro_grupo: true},
        visible: false,
        now: '',
        prc: {
          h_lookup_type: 'PROCESOS_LIQ_OCA',
          use_code: true,
          concat_text_code: true
        },
        code_currency: {
          h_lookup_type: 'MONEDA',
          use_code: true
        },
        status: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          valoresExpandidos: [
            {label: 'Moneda Liq', column: 'currency'},
            {label: 'Proceso', column: 'prc'},
            {label: 'Centro de Costo', column: 'cc_name'},
            {label: 'Estado', column: 'status_desc'},
            {label: 'Descripción', column: 'description'},
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          endpoint: 'oca',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'novelty_id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: 'Empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre Completo', dataIndex: 'full_name', sorter: true},
              {title: 'ID del concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true},
              {title: 'Unidad', dataIndex: 'oca_und', sorter: true, align: 'right'},
              {title: 'Vlr Base', dataIndex: 'oca_base', sorter: true, align: 'right'},
              {title: 'Vlr Local', dataIndex: 'oca_valor_l', sorter: true, align: 'right'},
              {title: 'Fecha Liquidación', dataIndex: 'oca_date_liq_mask', sorter: true},
              {title: 'Fecha Novedad', dataIndex: 'oca_date_reg_mask', sorter: true},
              {title: 'Documento', dataIndex: 'oca_document', sorter: true},
              {title: 'Centro de costo', dataIndex: 'nombre_centro_costo', sorter: true},
              {title: 'Unidad cc', dataIndex: 'nombre_unidad', sorter: true},
              {title: 'Proyecto cc', dataIndex: 'nombre_proyecto', sorter: true},
              {title: 'Segmento cc', dataIndex: 'nombre_segmento', sorter: true}
            ],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    if (this.$userIsInrol('Query')) {
                      return false
                    }
                    if (record.status === 'ACT' || (record.status === 'CER' && (this.$userIsInrol('RightHand') || this.$userIsInrol('Management')))) {
                      return true
                    }
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    if (this.$userIsInrol('Query')) {
                      return false
                    }
                    if (record.status === 'CER' && (this.$userIsInrol('RightHand') || this.$userIsInrol('Management'))) {
                      return true
                    } else if (record.status === 'ACT') {
                      return true
                    }
                  }
                }
              ]
            },
            allowSelect: true,
            selectedRows: [],
            selectedRowKeys: []
          },
          modalFieldsSetup: [
            {name: 'created_by'},
            {name: 'created_on'},
            {name: 'currency'},
            {name: 'description'},
            {name: 'id_cc'},
            {name: 'id_coc'},
            {name: 'id_emp'},
            {name: 'modified_by'},
            {name: 'modified_on'},
            {name: 'novelty_id'},
            {name: 'oca_apl'},
            {name: 'oca_base'},
            {name: 'oca_date_liq'},
            {name: 'oca_date_reg'},
            {name: 'oca_date_system'},
            {name: 'oca_document'},
            {name: 'oca_tmp'},
            {name: 'oca_und'},
            {name: 'oca_usuario'},
            {name: 'oca_valor'},
            {name: 'oca_valor_l'},
            {name: 'prc'},
            {name: 'status'}
          ],
          actions: []
        }
      }
    },
    methods: {
      objectoEmpleadoSeleccionado () {
        let emp = ''
        if (!JsUtils.isEmpty(this.empleadoseleccionado)) {
          if (!JsUtils.isEmpty(this.empleadoseleccionado.value)) {
            emp = this.empleadoseleccionado.value
            this.id_emp = emp
          }
        }
      },
      modeloRecibido (value) {
        this.$refs.masterComponent.modal.form.setFieldsValue({
          id_cc: value
        })
      },
      handleOk () {
        this.visible = false
      },
      isRolQuery () {
        if (this.$userIsInrol('Query')) {
          this.master.actions = []
        }
      },
      limiteRegistroNovedad () {
        if (this.$userIsInrol('RightHand') || this.$userIsInrol('Management') || this.$userIsInrol('AdminNomina')) {
          this.master.actions.push({
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              fnVisible: () => !this.$userIsInrol('Query'),
              props: {icon: 'plus', type: 'button'}
            },
            {
              name: 'rowClone',
              text: 'Clonar',
              permisos: [],
              fnVisible: () => !this.$userIsInrol('Query'),
              props: {icon: 'plus', type: 'button'}
            }
          )
        } else {
          this.httpClient.getInstance().get('tiempo_limite')
            .then(response => {
              if (response.data[0].tiempolimite != '1') {
                this.visible = true
                this.master.actions.splice(0)
                this.master.actions.splice(0)
              } else {
                this.master.actions.push({
                    name: 'masterCreate',
                    text: 'Crear',
                    permisos: [],
                    fnVisible: () => !this.$userIsInrol('Query'),
                    props: {icon: 'plus', type: 'button'}
                  },
                  {
                    name: 'rowClone',
                    text: 'Clonar',
                    permisos: [],
                    fnVisible: () => !this.$userIsInrol('Query'),
                    props: {icon: 'plus', type: 'button'}
                  }
                )
              }
            })
            .catch(() => {
              Mensajes.error('Error', 'No fue posble cargar el tiempo límite para registrar una novedad')
            })
        }
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.verCar = false
            this.id_emp = null
            this.$refs.masterComponent.modal.form.setFieldsValue({
              id_emp: undefined
            })
            break
          case 'masterEdit':
            this.verCar = false
            this.id_emp = action.record.id_emp
            this.empleadoseleccionado = {value: action.record.id_emp}
            this.objectoEmpleadoSeleccionado()
            if (!JsUtils.isEmpty(action.record.id_coc)) {
              this.$refs.cocComponent && this.$refs.cocComponent.handleSearch(action.record.id_coc)
            }
            if (!JsUtils.isEmpty(action.record.id_emp)) {
              this.$refs.empComponent && this.$refs.empComponent.handleSearch(action.record.id_emp)
            }
            break
          case 'rowClone':
            if (JsUtils.isEmpty(this.cloneTorecord)) {
              Mensajes.error('Error', 'Selecciona una fila para colonar')
              return
            }
            this.$confirm({
              title: 'Clonar',
              content: '¿Está seguro que desea clonar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().post(this.master.endpoint, {
                    ...this.cloneTorecord
                  })
                    .then((response) => {
                      let key = this.master.tableSetup.tableConfig.rowKey
                      let clone = {...this.cloneTorecord}
                      clone[key] = response.data[key]
                      this.$refs.masterComponent.$refs.datatable.data.unshift(clone)
                      this.$refs.masterComponent.$refs.datatable.handleRadioSelection(response.data)
                      this.master.tableSetup.selectedRowKeys = [response.data[key]]
                      this.master.tableSetup.selectedRows = [response.data]
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible clonar el registro'))
                      reject(error)
                    })
                })
              },
              onCancel () {
              }
            })
            break
          case 'fieldsChange':
            if (this.$getConfigValue('MOSTRAR_ALERTA_VALI_FECHA_INI_NOV_VS_FECHA_INI_EMP', 'NO') === 'SI') {
              if (!JsUtils.isEmpty(action.changedFields) &&
                !JsUtils.isEmpty(action.changedFields.oca_date_reg)) {
                this.fecha_inicio = action.changedFields.oca_date_reg.value
                if (!JsUtils.isEmpty(this.id_emp) && !JsUtils.isEmpty(this.fecha_inicio)) {
                  this.validarFechaIniNov(this.id_emp, this.fecha_inicio)
                }
              }
            }
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      },
      loadData () {
        this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
      },
      downloadTemplate () {
        this.loadingTemplate = true
        this.httpClient.getInstance().get('template_oca/download', {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          this.loadingTemplate = false
        })
      },
      validarFechaIniNov (idEmp, fechaIni) {
        this.httpClient.getInstance().post('validar_fecha_ini_nov', {
          id_emp: idEmp,
          fecha_inicio: fechaIni
        })
          .then((response) => {
            if (parseInt(response.data) !== 0) {
              this.verCar = true
              this.error = response.data
            } else {
              this.verCar = false
            }
          })
          .catch((error) => {
            this.verCar = true
            this.error = this.$getErrorMessage(error, 'No fue posible validar la fecha inicial, contacte al administrador.')
          })
      }
    },
    computed: {
      cloneTorecord () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      paramsExcel () {
        return {...this.paramsT}
      },
      roleLoad () {
        return this.$userIsInrol('Load')
      }
    },
    watch: {
      empleadoseleccionado () {
        this.objectoEmpleadoSeleccionado()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/Ocasionales.vue